import React from "react";
import {Link} from "react-router-dom";
import ButtonT from "../atoms/ButtonT";
import SearchBox from "../atoms/SearchBox";
import Title from "../atoms/Title";
import Button from "../atoms/Button";
import TableSearchBox from "./TableSearchBox";

const TableSearchHeader = ({
                               title,
                               number,
                               buttnText,
                               person,
                               placeholder,
                               onSearchBtnClick,
                               onClick,
                               path,
                               exportFile,
                               borderBlue,
                               hasBtn,
                               onClearFiltersClick,
                               clearFiltersVisibility,
                               counttext,
    countUnit="نفر"
                           }) => {
    return (
        <div className="flex flex-row justify-between items-center h-10 mb-7.5px">
            <div className="flex flex-row">
                <Title text={title}/>
                {number > 0 && (
                    <span
                        className="text-dark-blue-200 text-13 flex items-center before:content-dot mr-2.5 before:pl-2.5 ">
            تعداد کل : {" "}
                        <span className="pr-1">
              {number}
                            <span className="pr-1">{counttext ? counttext : countUnit}</span>
            </span>
          </span>
                )}
                {person && <span>"{person}"</span>}
            </div>
            <div className="flex items-center flex-row gap-3.6">
                {
                    clearFiltersVisibility && (
                        <p className={"text-12 cursor-pointer text-red underline"}>
                            حذف فیلتر ها
                        </p>
                    )
                }

                <TableSearchBox
                    placeholder={placeholder}
                    onSearchBtnClick={onSearchBtnClick}
                    isCancelVisible={false}
                    onCancelSearchClick={() => {
                        console.log("CLCIKKKKK")
                    }}
                />
                {/* Render button based on the condition */}
                {
                    hasBtn && (
                        <>
                            {exportFile ? (
                                // Button for exporting file
                                <a href={path} download>
                                    <ButtonT text={buttnText} onClick={onClick} borderBlue={borderBlue}/>
                                </a>
                            ) : (
                                // Button for navigation or action
                                <Link to={path}>
                                    <ButtonT text={buttnText} onClick={onClick} borderBlue={borderBlue}/>
                                </Link>
                            )}
                        </>
                    )
                }


            </div>
        </div>
    );
};

export default TableSearchHeader;
